// src/components/main/Main.jsx
import React, { useState, useCallback } from "react";
import "../../styles/desktop/main.css";

import CampoImagem   from "../CampoImagem/campoimagem";
import Menu          from "../menu/menu";
import TextMain      from "../Texto Principal/textoMain";
import Agendamentos  from "../Agendamento/agendamento";
import Loader        from "../loader/loader";
import Exaustor      from "../Exaustores/exaustores";
import Eventos       from "../events/eventos";
import background    from "../../assets/img/background.png";
import pagina1       from "../../assets/img/Pagina01.png";


import Grupo01       from "../Campo Luzes/Grupo01";
import AlarmeModal   from "../Alarme/AlarmeModal";

import ChatBot       from "../Plus/ChatBot/chatbot";
import PLUS          from "../Plus/plus";
import Dispositivos  from "../Plus/Dispositivos/dispositivo";
import Gestao        from "../Gestao/gestao";

// Hooks
import useEventos from "../../hooks/useEventos";
import useAlarmes from "../../hooks/useAlarmes";
import useMonitoramento from "../../hooks/useMonitoramento";

/**
 * Páginas que devem limpar a imagem central
 */
const alarmPages = [
  "CaixaDAgua",
  "CentralAlarmeIncendio",
  "Bombas",
];

const clearImagePages = [
  "Agendamentos",
  "Alarme",
  "Exaustor",
  "Gestao",
  "Chatbot",
  "PLUS",
  ...alarmPages, // inclui também as páginas de alarme
];

export default function Main() {
  const [paginaAtual, setPaginaAtual] = useState("Térreo");
  const [filtro, setFiltro]           = useState("Todos");
  const [loadingImage, setLoadingImg] = useState(false);
  const [imagemCentral, setImagemCentral] = useState(pagina1);

  const { eventos, chamados, loading: eventosLoading, carregarEventos } = useEventos();
  const { caixas, bombas, status, alarmActive, tipoAlarmeAtivo } = useAlarmes();

  const {
    cieData,
    loading: monitoramentoLoading,
    fetchCieData,
    getDeviceStatus,
    formatDateTime,
    getActiveAlerts,
    getDeviceSeverity
  } = useMonitoramento();

  const monitoramentoUtils = {
    cieData,
    loading: monitoramentoLoading,
    fetchCieData,
    getDeviceStatus,
    formatDateTime,
    getActiveAlerts,
    getDeviceSeverity
  };


  /**
   * Mapeamento entre imagens e componentes de grupo
   */
  const groupComponents = {
    [pagina1]: <Grupo01 />,
  };

  /**
   * Troca a página atual. Se a página estiver em `clearImagePages`, limpa a imagem central.
   */
  const trocarPagina = useCallback((p) => {
    if (clearImagePages.includes(p)) {
      setImagemCentral("");
    }
    if (p === "history") setFiltro("Todos");
    setPaginaAtual(p);
  }, []);

  /**
   * Exibe o loader antes de trocar a imagem central
   */
  const loaderImage = useCallback(() => {
    setPaginaAtual(pagina1);
    setLoadingImg(true);
    setTimeout(() => setLoadingImg(false), 1000);
  }, []);

  /**
   * Troca a imagem central e dispara o loader
   */
  const trocarImagem = useCallback(
    (img) => {
      if (imagemCentral !== img) {
        loaderImage();
        setImagemCentral(img);
      }
    },
    [imagemCentral, loaderImage]
  );

  /**
   * Renderiza o grupo correspondente à imagem ou página atual
   */
  const renderGroup = () =>
    groupComponents[imagemCentral] || groupComponents[paginaAtual] || null;

  /**
   * Renderiza o conteúdo principal de acordo com a página atual
   */
  const renderPageContent = () => {
    // Primeiro, verifica se é uma página de alarmes
    if (alarmPages.includes(paginaAtual)) {
      return <AlarmeModal caixas={caixas} bombas={bombas} status={status} page={paginaAtual} monitoramentoUtils={monitoramentoUtils} />;
    }

    switch (paginaAtual) {
      case "Agendamentos":
        return <Agendamentos />;
      case "Exaustor":
        return <Exaustor />;
      case "Chatbot":
        return <ChatBot />;
      case "history":
        return (
          <Eventos
            filtro={filtro}
            eventos={eventos}
            loading={eventosLoading}
            atualizarLista={carregarEventos}
            chamados={chamados}
          />
        );
      case "PLUS":
        return <PLUS />;
      case "Dispositivos":
        return <Dispositivos />;
      case "Gestao":
        return <Gestao />;
      default:
        // Páginas que usam planta/fundo
        return (
          <>
            {imagemCentral && (
              <CampoImagem imagem={imagemCentral} loadingImage={loadingImage} />
            )}
            {renderGroup()}
          </>
        );
    }
  };

  return (
    <div id="divMain">
      {eventosLoading && <Loader />}

      <Menu
        trocarPagina={trocarPagina}
        trocarImagem={trocarImagem}
        paginaAtual={paginaAtual}
        paginas={[pagina1]}
        alarmStatus={alarmActive}
        tipoAlarmeAtivo={tipoAlarmeAtivo} // ✨ Adicionar esta linha
      />

      <div id="content" style={{ backgroundImage: `url(${background})` }}>
        <TextMain />
        {paginaAtual === "Gestao" ? (
          <Gestao />
        ) : (
          <div id="content-Central">{renderPageContent()}</div>
        )}
      </div>
    </div>
  );
}